import * as React from "react";

import Header from "components/header";
import { HeaderInMainScanningResult } from "components/header-in-main";
import { DashboardScanningResult } from "components/dashboard";
import { FilterTitlesModal } from "components/modal";

import "./ScanningResult.scss";
import { closeModal, openModal } from "core/state/modal/actions";
import { connect } from "react-redux";
import { getActiveModalName } from "core/state/modal/selectors";
import { StoreShape } from "core/reducers";
import { getTitlesSelected } from "core/state/meta/selectors";
import { countTrue } from "common/utils";
import { loadTitles } from "core/state/titles/actions";
import {
  loadWebsiteLinks,
  loadWebsites,
  loadWebsiteTypes
} from "core/state/websites/actions";
import { fetchCountries } from "core/state/meta/actions";
import { withPackageDataLoader } from "components/dataHOC/mountLoaders";

const MODAL_NAME = "FilterTitlesModal";

const Page: React.SFC<{
  projectId: string;
  titlesSelected: number;
  activeModal: string;
  openFilterModal: () => void;
  closeFilterModal: () => void;
}> = ({
  titlesSelected,
  projectId,
  activeModal,
  openFilterModal,
  closeFilterModal
}) => (
  <div className="page">
    <Header className="page__header" />
    <main className="page__main">
      <HeaderInMainScanningResult
        className="page__navigation"
        titlePage="Scanning results"
        captionSelected={`${titlesSelected} Titles selected`}
        onCaptionSelectedClick={openFilterModal}
        projectId={projectId}
      />
      <DashboardScanningResult
        className="page__dashboard"
        projectId={projectId}
      />
    </main>
    <FilterTitlesModal
      className="page__modal"
      visible={activeModal === MODAL_NAME}
      onClose={closeFilterModal}
    />
  </div>
);

const mapStateToProp = (
  state: StoreShape,
  { projectId }: { projectId: string }
) => ({
  activeModal: getActiveModalName(state),
  titlesSelected: countTrue(getTitlesSelected(state, projectId))
});

const mapDispatchToState = (dispatch: any) => ({
  openFilterModal: () => dispatch(openModal(MODAL_NAME)),
  closeFilterModal: () => dispatch(closeModal(MODAL_NAME))
});

export default withPackageDataLoader({
  page: [fetchCountries],
  hook: [loadTitles, loadWebsites, loadWebsiteTypes, loadWebsiteLinks]
})(connect(mapStateToProp, mapDispatchToState)(Page));
